import { ComplianceTypes } from '@/constants';

export type MemberRole = {
  roleId: 'member_admin';
  organizationId: string;
};

export type UserProfile = {
  firstName?: string;
  lastName?: string;
  email: string;
  onboardingCompletedAt?: string;
  userCreatedAt: string;
  jobTitle?: string;
  companyName?: string;
  memberRoles?: MemberRole[];
};

export const PlanSegment = {
  B2B: 'b2b',
  B2C: 'b2c',
} as const;

export const PurchaseType = {
  FREE_TRIAL: 'free_trial',
  B2B_FREE: 'b2b_free',
  B2B_PAID: 'b2b_paid',
  B2C_PAID: 'b2c_paid',
  PAY_AS_YOU_GO: 'pay_as_you_go',
  TEAM_TRIAL: 'team_trial',
  TEAM_PAID: 'team_paid',
} as const;

export type Plan = {
  planState: 'active' | 'grace_period' | 'depleted';
  validFrom: string;
  /** Expiry Date + Grace Period */
  validUntil?: string;
  totalCredits?: number;
  /** Total redemptions _of the user_, i.e. `organization_member_used_credits` */
  totalRedemptions: number;
  cap?: number;
  usageRemaining?: number;
  showUsageRemaining: boolean;
  licenceValid: boolean;
  segment: (typeof PlanSegment)[keyof typeof PlanSegment];
  purchaseType: (typeof PurchaseType)[keyof typeof PurchaseType];
  organizationName: string;
  organizationId: string;
  organizationMemberUsageCapValid: boolean;
  unenforcedLimits?: {
    totalCredits?: number;
    validUntil?: string;
  };
  rules: string[];
} | null;

export type ComplianceType = keyof typeof ComplianceTypes;
